import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appDateTime',
    standalone: false
})
export class AppDateTimePipe implements PipeTransform {

  constructor(private datepipe: DatePipe) { }

  transform(value: string | number | Date, args?: any): string {
    if(args && args.length > 0) {
      return this.datepipe.transform(value, `d-MMM-YYYY ${args[0]}`);
    } else {
      return this.datepipe.transform(value, 'd-MMM-YYYY HH:mm:ss');
    }
  }

}
